import { Box, Grid, MenuItem, TextField } from '@mui/material';
import { CodeSet } from '@src/constants/CodeSets';
import { UseFormRegister } from 'react-hook-form';

interface Region {
  code: string;
  name: string;
}

export interface HospitalFormValues {
  shortCode: string;
  name: string;
  codeSet: string;
  regionCode: string;
}

interface Props {
  formId: string;
  fieldClassName: string;
  register: UseFormRegister<HospitalFormValues>;
  regions: Region[];
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  regionCode: string;
  setRegionCode: (value: string) => void;
  mode: 'add' | 'edit';
}

function HospitalsForm({
  formId,
  fieldClassName,
  register,
  regions,
  onSubmit,
  regionCode,
  setRegionCode,
  mode,
}: Props) {
  return (
    <form id={formId} onSubmit={onSubmit}>
      <Box sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              className={fieldClassName}
              {...register('name', { required: 'Hospital name is required' })}
              required
              label="Hospital name"
              variant="outlined"
              InputLabelProps={mode === 'edit' ? { shrink: true } : undefined}
              inputProps={{ autoComplete: 'off' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              className={fieldClassName}
              {...register('regionCode', { required: 'Region is required' })}
              required
              label="Region"
              onChange={(e) => setRegionCode(e.target.value)}
              variant="outlined"
              inputProps={{ autoComplete: 'off' }}
              value={regionCode ?? ''}>
              {regions.map((region) => (
                <MenuItem key={region.code} value={region.code}>
                  {region.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              className={fieldClassName}
              {...register('codeSet', { required: 'Code set is required' })}
              required
              label="Code set"
              variant="outlined"
              inputProps={{ autoComplete: 'off' }}
              defaultValue={CodeSet.OPCS}>
              <MenuItem value={CodeSet.OPCS}>{CodeSet.OPCS}</MenuItem>
              <MenuItem value={CodeSet.CCSD}>{CodeSet.CCSD}</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              className={fieldClassName}
              {...register('shortCode', {
                required: 'Hospital short code is required',
              })}
              required
              label="Short code"
              variant="outlined"
              InputLabelProps={mode === 'edit' ? { shrink: true } : undefined}
              disabled={mode === 'edit'}
              inputProps={{ autoComplete: 'off' }}
            />
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}

export default HospitalsForm;
export type { Region };
